// extracted by mini-css-extract-plugin
module.exports = {"Input":"Checkbox_Input__2-t1z","Label":"Checkbox_Label__2vI_V","InputElement":"Checkbox_InputElement__3Ptfs","Invalid":"Checkbox_Invalid__2s6Sv"};